var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotAirBalloon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 46,
    viewBox: "0 0 36 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 17.2764C2 26.4192 13.4286 33.2764 13.4286 33.2764H22.5714C22.5714 33.2764 34 26.4192 34 17.2764C34 8.13351 26.8366 1.27637 18 1.27637C9.16344 1.27637 2 8.13351 2 17.2764Z",
    stroke: "url(#paint0_linear_2592_10415)",
    strokeWidth: 2.5,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.27686C5.99992 14.2769 14 33.2769 14 33.2769",
    stroke: "url(#paint1_linear_2592_10415)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7686 2.27686C29.7686 14.2769 21.7686 33.2769 21.7686 33.2769",
    stroke: "url(#paint2_linear_2592_10415)",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 44.2759H15.2C14.5372 44.2759 14 43.7387 14 43.0759V39.4759C14 38.8131 14.5372 38.2759 15.2 38.2759H20.8C21.4628 38.2759 22 38.8131 22 39.4759V43.0759C22 43.7387 21.4628 44.2759 20.8 44.2759Z",
    stroke: "url(#paint3_linear_2592_10415)",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2592_10415",
    x1: -16.8965,
    y1: 4.2308,
    x2: 148.855,
    y2: 121.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2592_10415",
    x1: 7.26981,
    y1: 5.13896,
    x2: 39.8643,
    y2: 8.2881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2592_10415",
    x1: 19.2698,
    y1: 5.13896,
    x2: 51.864,
    y2: 8.28804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2592_10415",
    x1: 9.27587,
    y1: 38.8298,
    x2: 42.1734,
    y2: 69.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE0C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1865,
    stopColor: "#D82E78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4246,
    stopColor: "#E35353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6462,
    stopColor: "#EB6D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8429,
    stopColor: "#F07D28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    stopColor: "#F28322"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotAirBalloon);
export default __webpack_public_path__ + "static/media/hot-air-balloon.4b0cd7c8a9dc6fd5def8ff3ccf6c34a1.svg";
export { ForwardRef as ReactComponent };